module.exports = __webpack_public_path__ + "static/media/Trade Gothic B-01.63397e28.svg";